export default __webpack_public_path__ + "static/media/meet.56f27218.png";